import { Redirect, useParams } from 'react-router-dom';

// Old URL (/company) is not part of the new site: send it to the about page.
const ToAbout = () => {
  const { language } = useParams();
  return <Redirect to={`/${language}/about`} />;
};

export default ToAbout;
